import Login from '@/components/Login'
import GlobalSignaling from '@/components/GlobalSignaling'
import chat from '@/components/Chat/Chat.vue';
import LeftSidebar from '@/components/LeftSidebar/LeftSidebar.vue';
import overlay from '@/components/overlay/Overlay'
import CalleePeer from "@/components/CalleePeer"

import RightSidebar from '@/components/RightSidebar/RightSidebar.vue';
import SmallOverlay from '@/components/SmallOverlay/SmallOverlay.vue';
import { serverBus, i18n } from '@/main'
import Global  from '@/scripts/Global'
import SessionManager from '@/Manager/Session.manager'
import VueSignals from '@/scripts/VueSignals';
import MainApi from '@/scripts/api/main.api';
import router from '@/router';

let git_log = ''
if(Global.isTest()){
  git_log = require('raw-loader!../../git_log.txt')
}

// This is for using css @media on divs instead of screen size
var ElementQueries = require('css-element-queries/src/ElementQueries');

let globalViewMenu = null
let notficationBar = null

export default {
  name: 'app',
  data() {
    return {
      isLoggedIn: Global.isLoggedInCookie(),
      SplashScreen: true,
      alr: false,
      git_log:'',
      currentRoute: window.location.pathname,
      isURLPath: false,
      sandBoxed: Global.isSandBox(),
      installBtn: 'block',
      showPWAIOS: false,
      isTest :Global.isDevelop() || Global.isTest(),
    }
  },
  components: {
    Login,
    GlobalSignaling,
    chat,
    LeftSidebar,
    RightSidebar,
    overlay,
    SmallOverlay,
    CalleePeer
  },

  created(){
    if(!Global.isDevelop()){
      document.domain = "cloudplan.net"
    }

    if(Global.isDevelop() || Global.isTest()){
      this.git_log = git_log
    }

    Global.DetectAgent()
    if(Global.isELectron()){
      router.push('install')
    }
  },
  mounted() {
    if(!Global.isDevelop() && !Global.isTest()){
      console.log('%c STOP! ', 'background: #222; color: red; font-size:64px; font-weight: 800;')
      console.log('%c This is a browser feature for developers. If someone told you to copy paste something that will be a scam. ', 'color: red; font-size:42px; font-weight: 600;')
    }

    if(!this.isLoggedIn && !Global.getAlr()){
      this.SplashScreen= false
      Global.Splash(0)
    }
    this.isURLPath = Global.isURLPath()
    let pageURL = new URL(Global.getRootWindow(window).location.href)
    this.alr = window.location.href.indexOf('alr') > -1;
    let URLParams = pageURL.searchParams
    // this.CheckAnonymousLoginRequest()
    this.CheckIfRequestNotifications(pageURL)
    this.CheckURLFromContact(pageURL, URLParams)
    this.CheckURLChannel(pageURL)
    this.CreateNavigateQueue()
    this.CheckLoginNavigate(pageURL)

    serverBus.$on(VueSignals.LOGGED_IN_USER, (ch_id) => {
      this.$i18n.locale = SessionManager.getLoggedInUser().chat_visuals.language // change language
    })

    serverBus.$on(VueSignals.SPLASH_SCREEN, (status) => {
      this.SplashScreen = status
    })

    serverBus.$on(VueSignals.IS_LOGGEDIN_USER, (logStatus) => {
      this.isLoggedIn = logStatus
    })

    serverBus.$on("showPWAIOS", (status) => {
      if(($cookies.isKey("showPWAIOS") && $cookies.get("showPWAIOS")) || !$cookies.isKey("showPWAIOS")){
        this.showPWAIOS = status
      }
    })

    //@TODO later implementation for
    // if ('serviceWorker' in navigator) {
      // window.addEventListener('load', () => {
      //   navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`)
      //       .then((reg) => {
      //         console.log('Service w orker registered.', reg);
      //       });
      // });
    // }




    /**GlobalView related  */

    globalViewMenu = document.getElementById("containerMenuGlobal")
    if(globalViewMenu != null){
      notficationBar = document.querySelector("#MainChat .notification-block")
      if(notficationBar != null){
          globalViewMenu.style.marginTop = 46
      }
    }

    // attaches to DOMLoadContent and does anything for you
    ElementQueries.listen();
    ElementQueries.init();

  },
  methods:{
    CheckIfRequestNotifications(pageURL) {
        if (pageURL.pathname.indexOf("notificationrequest") > -1) {
            this.isLoggedIn = false;
            this.SplashScreen = false;
            // this.$router.push('notificationrequest');
        }
    },
    CheckAnonymousLoginRequest(){
        // TODO: I think this should be global
      if(typeof this.$route.query.alr != 'undefined'){
        this.SplashScreen = true
        Global.removeAllCookies()
        Global.Splash(1)
        this.alr = true
        MainApi.authenticate('', '', this.$route.query.alr ).then(res => {
          if(res.data.result){
            Global.globalValue(VueSignals.AUTHENTICATED, true)
            Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
            Global.globalValue(VueSignals.SESSION_ID, res.data.session_id)
            Global.setSessionID(res.data.session_id)
            MainApi.setHeader(res.data.session_id)
          }else {
            this.isLoggedIn = false
            Global.logout()
            router.replace("login")
          }
        })
      }
    },
    CheckURLFromContact(pageURL, URLParams){
      if(pageURL.pathname.indexOf("contact") > -1 && this.isLoggedIn){
        Global.Splash(1)
        let contact_channel_id = URLParams.get('c')
        let contact_user_id = URLParams.get('u')
        if(contact_channel_id != null){
          Global.globalValue(VueSignals.CHANNEL_ID_FROM_CONTACT_LINK, contact_channel_id)
        }

        if(contact_user_id != null){
          Global.globalValue(VueSignals.USER_ID_FROM_CONTACT_LINK, contact_user_id)
        }
      }
    },
    CheckURLChannel(pageURL){
      //TODO:
      if(pageURL.pathname.indexOf('channel') > -1 && !Global.isLoggedInCookie() && !this.alr){
          window.location.href = window.location.href.slice(0, window.location.href.indexOf('/channel'))
          Global.removeAllCookiesExcept(['login_token', 'login_email', 'rememberPW'], true)
      }
    },
    CreateNavigateQueue(){
        /** back and forward buttons */
      Global.getRootWindow(window).addEventListener(
        'popstate', function(e){
          let pageURL = new URL(Global.getRootWindow(window).location.href)
          e.preventDefault()
          if(pageURL.pathname.indexOf('channel/') > -1){
            let channel = SessionManager.getChannel(pageURL.pathname.replace('/channel/', ''))
            if(typeof channel != 'undefined')
              SessionManager.setActiveChannel(channel)
          }
        }
      )
      /** back and forward buttons */
      Global.getRootWindow(window).addEventListener(
        'pushstate', function(e){
          e.preventDefault()
          let pageURL = new URL(Global.getRootWindow(window).location.href)
          if(pageURL.pathname.indexOf('channel/') > -1){
            let channel = SessionManager.getChannel(pageURL.pathname.replace('/channel/', ''))
            if(typeof channel != 'undefined')
              SessionManager.setActiveChannel(channel)
          }
        }
      )
    },
    CheckLoginNavigate(pageURL){
      if(pageURL.pathname == "/" && !Global.isLoggedInCookie() && typeof this.$route.query.alr == 'undefined'){
        router.replace("login")
      }
    },
    hidePWAIOS(){
      this.showPWAIOS = false
      $cookies.set("showPWAIOS", false)
    },
  }
}
